import { Form, Select, Image, Typography } from 'antd';
import ArrowDownIcon from "../../assets/icons/arrow-down-icon.svg"
import "./CustomSelect.scss"

const { Text } = Typography;

const CustomSelect = ({ label, isRequired, name, rules, options, placeholder, showSearch, className = "", optionRender, ...rest }) => {
    return (
        <Form.Item
            label={label && <Text>{label}{isRequired && <Text type="danger"> *</Text>}</Text>}
            name={name}
            rules={rules}
            className="custom-select"
        >
            <Select
                placeholder={placeholder}
                showSearch={showSearch}
                suffixIcon={<Image src={ArrowDownIcon} alt='Arrow Down' preview={false} />}
                optionFilterProp="label"
                filterOption={(input, option) =>
                    String(option?.label || "").toLowerCase().includes(input.toLowerCase())
                }
                optionLabelProp="label"
                options={options}
                optionRender={optionRender}
                className={`custom-select-dropdown ${className}`}
                {...rest}
            >
            </Select>
        </Form.Item>
    );
};

export default CustomSelect;
